import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ps1z99hoa: FaireProductEntity = {
  token: "p_6ps1z99hoa",
  type: "product",
  name: "Laughing Giraffe Baby Sleeping Gown with Fold Over Mittens",
  brandToken: "b_58wn0038",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1f95d92b89e43af060ecefa0167d29da04ca5dd40ef761bf3053f11cfaf2abc8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/343128e640a9b53810871b461529af16d3e111213e33125acf1b34403f4f9ad1.png",
    "https://cdn.faire.com/fastly/cd700f61c87000c8f7b9685d5ad690887dc538b9535b99115b2d1c719500efff.png",
    "https://cdn.faire.com/fastly/423eda59512ef53dbb7ff4b159fea58c732b166cf356ae2a9e52ea4ff8ea119b.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/23abab632e544aa344a07f32a8abc4b9260a46fc1a9561db9f51177cc0df1ff6/1545090365.png",
    "https://cdn.faire.com/fastly/a4d561fb81f7591aaeacfb764049417e1a717dbb1702960cbf94c15d347bb5f3.png",
    "https://cdn.faire.com/fastly/f37f17ad5c18b6aba16ae683b41d588834d892d8ccd38e764e82f2e50f91a66f.png",
    "https://cdn.faire.com/fastly/426db4a8f3bfd71140179381d46475ce1edd97c7660b8f507c593cd088778811.jpeg",
    "https://cdn.faire.com/fastly/3e18dc87d0eb2348307c2b49f60b7a5fc54f5d3baddf40515cb4fd1a4ef2f415.jpeg",
    "https://cdn.faire.com/fastly/3d9872e1c6a2af27755048b4225952940b07bc90152ae0f1fa5ffb9c326fe20c.jpeg",
    "https://cdn.faire.com/fastly/58ada2011919f3e8dae7d337315c0a3a1f86f9fbc46446ca3fc3ac83c72d287e.jpeg",
    "https://cdn.faire.com/fastly/1a91bbfea502c70e94fa6b3b2bc1983f26cc5d325998dc52c99bf87bf8e8a1e2.jpeg",
    "https://cdn.faire.com/fastly/12faa43e79da1bfc7e971248c1da0309544672eb92d6539a81d208ecdca537c5.png",
    "https://cdn.faire.com/fastly/0785882107c656d5bff9727c2bc633106d29d4ea89ca4bf6302a4411fbaec823.png",
    "https://cdn.faire.com/fastly/b419529754269e0b3a38dd9eec10c2ba2983f6b2d44d80bd09617e92d521cb76.png",
  ],
  priceDollars: 6.58,
  description:
    "Baby Blank Sleeping Gown has a buttery soft feel, keeping your baby cozy and protected through the night. \n\nFEATURES:\n➼ Long Sleeve style with attached fold-over mittens to protect from scratches. \n➼ Stretchy hem to keep feet warm and covered. \n➼ Elastic bottom for easy diaper changes without the hassle of zippers and snaps. \n➼ Flexible shoulder lap neckline for quick dressing.\n\nGreat Baby Shower Gift, Gifts for New Moms, Gifts for New Parents, Custom Baby Gifts, DIY Baby Projects, Personalized Baby Gifts, Newborn Baby, Baby Gender Reveal, Pregnancy Announcement, Baby Showers, Birthday Parties, Valentine’s Day, Halloween, Christmas, New Years, Thanksgiving, 4th of July or just a simple stroll around the park or mall, your baby will stay stylish and cute.\nPersonalize these gowns with your baby's initials, name or nickname.\n\n🦒 We are The Laughing Giraffe ® 🦒 US-based Supplier born in 2000, we specialize in Blanks Clothing for Babies, Toddlers, and Youth!",
  tags: [],
  msrpDollars: 13.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:33.009Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
